/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Error_Uploadteaser2Inputs */

const en_coinvestments_error_uploadteaser2 = /** @type {(inputs: Coinvestments_Error_Uploadteaser2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to upload teaser document`)
};

/**
* | output |
* | --- |
* | "Failed to upload teaser document" |
*
* @param {Coinvestments_Error_Uploadteaser2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_error_uploadteaser2 = /** @type {((inputs?: Coinvestments_Error_Uploadteaser2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Error_Uploadteaser2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_error_uploadteaser2(inputs)
});
export { coinvestments_error_uploadteaser2 as "coInvestments_error_uploadTeaser" }